import { AppEffect } from './app.effect';
import { BookingEffect } from './booking.effect';
import { FlightEffect } from './flight.effect';
import { BagEffect } from './bag.effect';
import { UserEffect } from './user.effect';
import { SeatEffect } from './seat.effect';
import { ResourceEffect } from './resource.effect';
import { PaymentEffect } from './payment.effect';
import { PassengerEffect } from './passenger.effect';
import { StationEffect } from './station.effect';
import { AvailabilityEffect } from './availability.effect';
import { FlightInfoEffect } from './flight-info.effect';
import { NavigateEffect } from './navigate.effect';
import { ExtrasEffect } from './extras.effect';
import { MealEffect } from './meal.effect';
import { GtmEffect } from './gtm.effect';
import { CheckInEffect } from './check-in.effect';
import { CmsEffect } from './cms.effect';
import { CultureEffect } from './culture.effect';
import { PlusgradeEffect } from './plusgrade.effect';
import { CoverGeniusEffect } from './cover-genius.effect';
import { SmsVerificationEffect } from './sms-verification.effect';
import { HeadersEffect } from './headers.effect';
import { ApoEffect } from './apo.effect';
import { InvoiceEffect } from './invoice.effect';
import { BBoxEffect } from './bbox.effect';


type EffectType =
  | typeof AppEffect
  | typeof AvailabilityEffect
  | typeof BagEffect
  | typeof CmsEffect
  | typeof MealEffect
  | typeof BookingEffect
  | typeof ExtrasEffect
  | typeof FlightEffect
  | typeof FlightInfoEffect
  | typeof NavigateEffect
  | typeof PassengerEffect
  | typeof PaymentEffect
  | typeof ResourceEffect
  | typeof SeatEffect
  | typeof StationEffect
  | typeof UserEffect
  | typeof GtmEffect
  | typeof CheckInEffect
  | typeof CultureEffect
  | typeof PlusgradeEffect
  | typeof CoverGeniusEffect
  | typeof SmsVerificationEffect
  | typeof HeadersEffect
  | typeof ApoEffect
  | typeof InvoiceEffect
  | typeof BBoxEffect;

export const effects: EffectType[] = [
  AppEffect,
  AvailabilityEffect,
  BagEffect,
  CmsEffect,
  MealEffect,
  BookingEffect,
  ExtrasEffect,
  FlightEffect,
  FlightInfoEffect,
  NavigateEffect,
  PassengerEffect,
  PaymentEffect,
  ResourceEffect,
  SeatEffect,
  StationEffect,
  UserEffect,
  GtmEffect,
  CheckInEffect,
  CultureEffect,
  PlusgradeEffect,
  CoverGeniusEffect,
  SmsVerificationEffect,
  HeadersEffect,
  ApoEffect,
  InvoiceEffect,
  BBoxEffect,
];

export * from './app.effect';
export * from './availability.effect';
export * from './bag.effect';
export * from './meal.effect';
export * from './booking.effect';
export * from './extras.effect';
export * from './flight.effect';
export * from './flight-info.effect';
export * from './navigate.effect';
export * from './passenger.effect';
export * from './payment.effect';
export * from './resource.effect';
export * from './seat.effect';
export * from './station.effect';
export * from './user.effect';
export * from './gtm.effect';
export * from './check-in.effect';
export * from './culture.effect';
export * from './plusgrade.effect';
export * from './cover-genius.effect';
export * from './sms-verification.effect';
export * from './headers.effect';
export * from './apo.effect';
export * from './invoice.effect';
export * from './bbox.effect';